import React, { useState } from 'react'
import { firestore } from '../../../../../firebase';

function PlayerSavedTeam({player, index, numberOfTeams, draw, roundId, hostcupId, playersTeam, type, setNewDraw, sortCount, setSortCount}) {

    const [showEditPlayer, setShowEditPlayer] = useState(false)
    const [playerIndex, setPlayerIndex] = useState(index)

    const [teamName, setTeamName] = useState("A")

    const teams = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    function generateTeamName(index, numTeams, numPlayersTeam, playersCount) {   

        // STEP: playersPerTeam, for example 5
        // FOR EACH STEP: INCREMENT TEAM NAME BY 1
        function teamNumber(index) {
            let teamNumber = (index/numPlayersTeam);
            if (teamNumber === 0) {
                teamNumber = 1
            } else if (teamNumber/teamNumber === 1) {
                teamNumber = teamNumber + 0.1
            }
            //console.log(index/playersPerTeam)
            return Math.ceil(teamNumber)
        }
        function generateTeamNamePlayer(teamNumber) {

            return teams[teamNumber]
        }
        let finalTeamNumber
        
        const teamNumberGenerated = teamNumber(index-1);
        //console.log(teamNumberGenerated)

        // IF TEAM NUMBER GENERATED === 9 AND INDEX IS 9
        if (teamNumberGenerated === 9) {

            if (index > playersTeam) {
                //console.log(playersCount-index, "PLAYERSCOUNT - INDEX")
            }

            if ((playersCount - index) === 0) {
                finalTeamNumber = 1
            } else if ((playersCount - index) === 1) {
                finalTeamNumber = 2
            } else if ((playersCount - index) === 2) {
                finalTeamNumber = 3
            } else if ((playersCount-index) === 3) {
                finalTeamNumber = 4
            } else if ((playersCount-index) === 4) {
                finalTeamNumber = 5
            } else if ((playersCount-index) === 5) {
                finalTeamNumber = 6
            } else if ((playersCount-index) === 6) {
                finalTeamNumber = 7
            } else if ((playersCount-index) === 7) {
                finalTeamNumber = 8
            }

        } else {
            finalTeamNumber = teamNumberGenerated
        }

        const teamNameGenerated = generateTeamNamePlayer(finalTeamNumber-1);
        //console.log(teamNameGenerated, "Team NAme Generated")
        return teamNameGenerated;

    }

    async function savePlayerRound(e, player, teamNameGenerated, index) {

        e.preventDefault();
        try {
            const playerTeamsRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("player_scores");
            const data = {
                name: player.player_name,
                player_id: player.player_id,
                team_name: teamName,
                team_index: index
            }
            
            console.log(data)
            playerTeamsRef.add(data);
        } catch (error) {
            
        }

    }

    function editPlayer(player) {
        // Edit player here
        console.log(player)
        /*const playerToSwap = draw.filter(currentPlayer => {
            //console.log(currentPlayer.index, "===", +playerIndex)
            return currentPlayer.index === +playerIndex 
        })*/
        // FILTER OUT PLAYER FROM ARRAY
        const filteredArray = draw.filter(currentPlayer => {
            return currentPlayer.player_id !== player.player_id //(or player.player_id??)
        })

        //console.log(playerToSwap, "PLAYER TO SWITCH WITH")
        // ADD NEW EDITED PLAYER TO A NEW ARRAY
        const playerArray = [
            {
                player_name: player.player_name,
                index: +playerIndex,
                player_id: player.player_id,
                team_name: teamName
            }
        ]
        let newArray = filteredArray.concat(playerArray)

        console.log(playerArray, "player array")
        console.log(newArray, "New Array")
        // CONCAT FILTERED ARRAY AND NEW PLAYER ARRAY

        // Save updated table in state, and then possible to save to database
        setNewDraw(newArray)
        setSortCount(sortCount+1)
    }

    function removePlayer(player) {


        const filteredArray = draw.filter(currentPlayer => {
            return currentPlayer.player_id !== player.player_id //(or player.player_id??)
        })
        setNewDraw(filteredArray)

    }

    function toggle() {
        if (showEditPlayer) {
            setShowEditPlayer(false)
        } else {
            setShowEditPlayer(true)
        }
    }

    return (
        <React.Fragment>
            <div>
                <div>
                    {player.team_name} {player.player_name}
                    <span className="px-1 float-right"> 
                        
                        {type === "Saved" &&  (
                            <React.Fragment>
                                <i onClick={e => savePlayerRound(e, player, generateTeamName(index+1, numberOfTeams, playersTeam, draw.length), index)} className={`fas fa-check`}></i>
                                <i className="pl-2 fas fa-edit text-primary" onClick={toggle}></i>
                                <i className="pl-2 fas fa-trash text-danger" onClick={() => removePlayer(player)}></i>
                            </React.Fragment>
                            )}
                        
                    </span>
                </div> 
                {showEditPlayer && (
                    <div>
                        <label>Team Name</label>
                        <input className="form-control mb-2" placeholder="Lagnavn" onChange={e => setTeamName(e.target.value)} />
                        <label>Index</label>
                        <input type="number" placeholder="Index" className="form-control mb-2" value={playerIndex} onChange={e => setPlayerIndex(e.target.value)} />
                        <label></label>
                        <button onClick={() => editPlayer(player)}>Lagre endringer</button>
                    </div>
                )}
            </div>
            {index+1 % 4 === 0 && <hr /> }
        </React.Fragment>
    )

}
export default PlayerSavedTeam